import React, { useState } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "../../../page-demo/script";
import PortfolioModal from "./PortfolioModal";

const PortfolioList = [
    {
        image: 'image-9',
        category: 'APP Mobile',
        title: 'O Fazendeiro - É uma rede social exclusiva para fazendeiros',
        description: 'Uma rede social desenvolvida especificamente para o setor agrícola, permitindo que fazendeiros compartilhem experiências, técnicas e conectem-se com outros profissionais do campo.',
        link: 'https://ofazendeiro.app'
    },
    {
        image: 'image-12',
        category: 'Development',
        title: 'Rede ProCursos',
        description: 'Atuo como desenvolvedor na Rede Procursos, onde sou responsável pela criação de sistemas para automação de tarefas e desenvolvimento de novas soluções tecnológicas. Trabalho diretamente com o sistema Sponte, realizando integrações que vão desde o controle de acesso por catracas até pagamentos via Pix, conectando diretamente com o banco do cliente. Também desenvolvemos soluções para emissão automática de NFS-e, acionadas por gatilhos definidos com base no comportamento dos usuários.',
        link: 'https://procursos.com.br'
    },
    {
        image: 'image-10',
        category: 'APP Mobile',
        title: 'Academia Água Vida - Aplicativa para acompanhamento de Alunos',
        description: 'Aplicativo mobile desenvolvido para academias, permitindo o acompanhamento de treinos, agendamento de aulas e monitoramento do progresso dos alunos.',
        link: ''
    },
    {
        image: 'image-11',
        category: 'APP Mobile',
        title: 'Canalle - Delivery',
        description: 'Aplicativo de delivery com foco em restaurantes locais, oferecendo uma experiência completa de pedidos e entregas.',
        link: 'https://canalle.com.br'
    },
    {
        image: 'image-1',
        category: 'API',
        title: 'Multdesk - Sistema para gestão de atendimentos',
        description: 'Sistema completo para gestão de atendimentos ao cliente, com integração de múltiplos canais e automação de processos.',
        link: 'https://multdesk.com.br'
    },
    {
        image: 'image-2',
        category: 'Integração',
        title: 'Integração entre os sistemas Anota Ai e Ecomanda',
        description: 'Desenvolvimento de integração entre dois sistemas populares de gestão de restaurantes, permitindo sincronização de dados e automação de processos.',
        link: 'https://anota.ai'
    },
    {
        image: 'image-3',
        category: 'PIX',
        title: 'Projeto para automação de pagamentos e recebimentos com PIX',
        description: 'Solução desenvolvida para automatizar pagamentos e recebimentos utilizando a tecnologia PIX do Banco Central, utilizando vários bancos diferentes.',
        link: 'https://bcb.gov.br'
    },
    {
        image: 'image-4',
        category: 'Development',
        title: 'Chatbot automatizado utilizando dialogflow',
        description: 'Implementação de chatbot inteligente utilizando a plataforma Dialogflow para atendimento automatizado e eficiente.',
        link: 'https://dialogflow.cloud.google.com'
    },
    {
        image: 'image-1',
        category: 'API',
        title: 'Projeto em python para extração de dados em sistemas diversos',
        description: 'Desenvolvimento de scripts em Python para extração e processamento de dados de diferentes sistemas e fontes.',
        link: 'https://python.org'
    },
    {
        image: 'image-5',
        category: 'DW',
        title: 'Modelagem e construção de um Data Warehouse',
        description: 'Projeto de modelagem e implementação de um Data Warehouse para análise e processamento de grandes volumes de dados.',
        link: 'https://microsoft.com/sql-server'
    },
    {
        image: 'image-6',
        category: 'ApFix',
        title: 'Sistema para controle de manutenções em condominios',
        description: 'Sistema desenvolvido para gestão de manutenções e serviços em condomínios, com controle de ordens de serviço e histórico.',
        link: 'https://apfix.com.br'
    },
    {
        image: 'image-7',
        category: 'Whatsapp',
        title: 'Integração de sistemas com Whatsapp',
        description: 'Desenvolvimento de integração com a API do WhatsApp para comunicação automatizada e atendimento ao cliente.',
        link: 'https://developers.facebook.com/docs/whatsapp'
    },
    {
        image: 'image-8',
        category: 'API',
        title: 'Integração entre sistemas',
        description: 'Projeto de integração entre diferentes sistemas empresariais, permitindo a troca de dados e automação de processos.',
        link: 'https://multdesk.com.br'
    }
]

const Portfolio = () => {
    const [selectedProject, setSelectedProject] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    let title = 'Projetos',
    description = '"Você nunca sabe que resultados virão da sua ação. Mas se você não fizer nada, não existirão resultados."';
    
    const handleProjectClick = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedProject(null);
    };
        
    return(
        <React.Fragment>
            <div className="portfolio-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center">
                                <h2>{title}</h2>
                                <p>{description}<br /><i>Mahatma Gandhi</i></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="portfolio-slick-activation mt--70 mt_sm--40">
                    <Slider {...portfolioSlick2}>
                        {PortfolioList.map((value, index) => (
                            <div className="portfolio" key={index}>
                                <div className="thumbnail-inner">
                                    <div className={`thumbnail ${value.image}`}></div>
                                    <div className={`bg-blr-image ${value.image}`}></div>
                                </div>
                                <div className="content">
                                    <div className="inner">
                                        <p>{value.category}</p>
                                        <h4><a href="#portfolio-details">{value.title}</a></h4>
                                        <div className="portfolio-button">
                                            <a className="rn-btn" href="#" onClick={(e) => {
                                                e.preventDefault();
                                                handleProjectClick(value);
                                            }}>+ Detalhes</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
            <PortfolioModal 
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                project={selectedProject}
            />
        </React.Fragment>
    )
}

export default Portfolio;